import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { ColorMap, UploadExecutionMapRequest } from "../models/RecipeMap";
import { EventSourcePolyfill } from "event-source-polyfill";

export default class RecipeMapApi {
    private http: HTTPClient;
    private unAuthHttp: HTTPClient;
    private georasterUrl!: string;

    constructor(http: HTTPClient) {
        this.http = http;
        this.unAuthHttp = new HTTPClient();
        this.getGeorasterExternalUrl().then(url => {
            this.georasterUrl = url;
        });
    }

    public async getGeorasterToken(farmCode: number): Promise<string> {
        const url = `/precision-farming/api/v1/farm/${farmCode}/geoToken`;
        const res = await this.http.get(url);
        return res.data;
    }

    public async getGeorasterExternalUrl(): Promise<string> {
        const url = `/precision-farming/api/v1/config/url`;
        const res = await this.http.get(url);
        if (res.data.value === null) {
            return "/georaster";
        }
        return res.data.value;
    }

    public async getColorMap(farmCode: number, isVertical = false): Promise<ColorMap[]> {
        const res = await this.http.get(`/precision-farming/api/v1/farm/${farmCode}/colortables`, {
            params: {
                isVertical: isVertical
            }
        });
        return res.data;
    }

    public async getCustomVerticalColorMap(
        farmCode: number,
        calcId: number,
        minMax: string,
        isVertical = true
    ): Promise<ColorMap> {
        const res = await this.http.get(
            `/precision-farming/api/v1/farm/${farmCode}/${calcId}/custom-colortable/${minMax}`,
            {
                params: {
                    isVertical: isVertical
                }
            }
        );
        return res.data;
    }

    public getEStatus(calculationId: number, token: string): EventSource {
        const params = "calculationId=" + calculationId;

        const EventSource = EventSourcePolyfill;
        const url = `${this.georasterUrl}/api/v1/raster-calculations/status-event-stream?${params}`;
        return new EventSource(url, { headers: { Authorization: token } });
    }

    public async createExecutionMap(subjectId: number, campaign: number, request: UploadExecutionMapRequest) {
        const res = await this.http.post(
            `/precision-farming/api/v1/farm/${subjectId}/${campaign}/upload-map/shapefile`,
            request
        );
        return res.data;
    }

    public async downloadRecipeMap(calculationId: number, token: string): Promise<Blob> {
        const url = `${this.georasterUrl}/api/v1/raster-calculations/${calculationId}.tif`;
        return (await this.unAuthHttp.get(url, { responseType: "blob", headers: { Authorization: `Bearer ${token}` } }))
            .data;
    }
}
